module.exports = __webpack_public_path__ + "static/media/sun.a0e76d56.svg";